<div class="flex justify-center">
	<div *ngIf="error != null">
		{{ error }}
	</div>
</div>

<form
	#syncForm="ngForm"
	(ngSubmit)="onSubmit(syncForm)"
	class="px-8"
	*ngIf="primary"
>
	<app-teranet-sync-inner-form
		[form]="syncForm"
		(onError)="setError($event)"
		(onSyncStatusUpdate)="setSyncStatus($event)"
		(onSyncSuccess)="onSyncSuccess($event)"
		[submit$]="submitSubject.asObservable()"
	></app-teranet-sync-inner-form>
</form>

<app-teranet-no-pin *ngIf="!primary"></app-teranet-no-pin>
